import { render, staticRenderFns } from "./DamageLossesDetail.vue?vue&type=template&id=f15f39c6"
import script from "../../controllers/damage-losses/damage-losses-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/damage-losses/damage-losses-detail.js?vue&type=script&lang=js&external"
import style0 from "./DamageLossesDetail.vue?vue&type=style&index=0&id=f15f39c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports